import React from "react";
import { Box, Typography, List, ListItem, ListItemText } from "@mui/material";
import { PieChart } from "@mui/x-charts/PieChart";

const statusColors = [
  "#4CAF50", // Completed

  "#FFC107", // Pending
  "#F44336", // Failed
  "#3F51B5", // Read

  "#009688", // Delivered
  "#E91E63", // Reattempted

  "#FF9800", // Processing
  "#03A9F4", // Queued
  "#673AB7", // Cancelled
  "#9E9E9E", // On Hold
];

const Analytics = ({ data, name }) => {
    const [radius] = React.useState(50);

    // Transform data into label/value pairs
    const transformedData = data.map((item) => {
        const [label, value] = Object.entries(item)[0];
        return { label, value };
    });

    // Filter out zero-value entries for the pie chart
    const pieChartData = transformedData.slice(0, -1); // Optional: limit to 3 categories

    // Total sum (for conditional rendering)
    const totalValue = transformedData.reduce(
        (sum, item) => sum + item.value,
        0
    );

    return (
        <Box
            sx={{
                // width: "100%",
                padding: "1rem",
                display: "flex",
                alignItems: "flex-start",
                flexWrap: "wrap",
                gap: 2,
            }}
        >
            {/* Conditionally render PieChart only if data has value */}
            {totalValue > 0 ? (
                <PieChart
                    height={300}
                    width={500}
                    series={[
                        {
                            data: pieChartData,
                            innerRadius: radius,
                            arcLabel: (params) => params.label ?? "",
                            arcLabelMinAngle: 20,
                        },
                    ]}
                    skipAnimation={false}
                />
            ) : // <Typography variant="body1" sx={{ minWidth: 300 }}>
            //     No data available to display in the chart.
            // </Typography>
            null}

            {/* Side panel */}
            <Box
                sx={{
                    flexGrow: 1,
                    border: 1,
                    borderColor: "#acadac",
                    padding: 5,
                    borderRadius: 1,
                    minWidth: 300,
                }}
            >
                <Typography variant="h6" gutterBottom>
                    {name} Delivery Report
                </Typography>
                <List>
                    {transformedData.map((status) => (
                        <ListItem key={status.label} divider>
                            <ListItemText primary={status.label} />
                            <Typography variant="body1">
                                {status.value}
                            </Typography>
                        </ListItem>
                    ))}
                </List>
            </Box>
        </Box>
    );
};

export default Analytics;
